import {connect} from 'react-redux';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ModalActions from '../../../actions/ModalActions';
import {withRouter} from 'react-router';
import BureauQueryErrorView from '../../../components/views/mx/seminuevos/BureauQueryErrorView';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapDispatchToProps = (dispatch) => {
    return {
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.BUREAU_ERROR);
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
            dispatch(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const BureauQueryErrorContainer = withRouter<any, any>(connect(
    null,
    mapDispatchToProps,
    mergeProps
)(BureauQueryErrorView));

export default BureauQueryErrorContainer;
